export const DRAG_START = 'state.actions.drag.DRAG_START' as const;

export type DragStartAction = {
	type: typeof DRAG_START;
};

export const dragStart = (): DragStartAction => ({
	type: DRAG_START,
});

export const DRAG_END = 'state.actions.drag.DRAG_END' as const;

export type DragEndAction = {
	type: typeof DRAG_END;
};

export const dragEnd = (): DragEndAction => ({
	type: DRAG_END,
});

export const BEFORE_CAPTURE = 'state.actions.drag.BEFORE_CAPTURE' as const;

export type BeforeCaptureAction = {
	type: typeof BEFORE_CAPTURE;
	payload: {
		sourceCardGroupType: string;
		sourceCardListId: string | undefined;
		isSubtask: boolean;
		sourceParentId: number | undefined;
	};
};

export const beforeCapture = (
	sourceCardGroupType: string,
	sourceCardListId: string | undefined,
	isSubtask: boolean,
	sourceParentId: number | undefined,
): BeforeCaptureAction => ({
	type: BEFORE_CAPTURE,
	payload: {
		sourceCardGroupType,
		sourceCardListId,
		isSubtask,
		sourceParentId,
	},
});

export const TRANSITION_ZONE_ENTER = 'state.actions.drag.TRANSITION_ZONE_ENTER' as const;

export type TransitionZoneEnterAction = {
	type: typeof TRANSITION_ZONE_ENTER;
};

export const transitionZoneEnter = (): TransitionZoneEnterAction => ({
	type: TRANSITION_ZONE_ENTER,
});

export const TRANSITION_ZONE_LEAVE = 'state.actions.drag.TRANSITION_ZONE_LEAVE' as const;

export type TransitionZoneLeaveAction = {
	type: typeof TRANSITION_ZONE_LEAVE;
};

export const transitionZoneLeave = (): TransitionZoneLeaveAction => ({
	type: TRANSITION_ZONE_LEAVE,
});

export type Action =
	| DragStartAction
	| DragEndAction
	| BeforeCaptureAction
	| TransitionZoneEnterAction
	| TransitionZoneLeaveAction;
